import * as React from 'react';

import { AvatarSize } from 'components/Avatar';
import cx from 'classnames';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import { TextSize } from 'components/Text';
import TextWithSubtext from 'components/TextWithSubtext';
import { MediaObjectGutter } from 'components/MediaObject';

import './AvatarWithText.scss';

export type Props = {
  avatar: React.ReactElement;
} & OptionalProps;

export type OptionalProps = {
  avatarSize?: AvatarSize;
  center?: boolean;
  icon?: React.ReactElement;
  level?: 'primary' | 'secondary' | 'profile';
  subtext?: string | React.ReactElement;
  subtextSize?: TextSize;
  subtle?: boolean;
  textSize?: TextSize;
  title?: string | React.ReactElement;
  gutter?: MediaObjectGutter;
};

export default function AvatarWithText({
  avatar,
  avatarSize,
  center = true,
  gutter = 'xsmall' as MediaObjectGutter,
  icon,
  level,
  subtext,
  subtextSize,
  subtle,
  textSize,
  title,
}: Props) {
  const avatarWithProps = React.cloneElement(avatar, { size: avatarSize || 'medium' });

  if (level === 'primary') {
    return (
      <Text align="center" element="div" className="AvatarWithText">
        <Row size="small">
          <div className="AvatarWithText-avatar">
            {avatarWithProps}
            {icon && <div className="AvatarWithText-avatar-icon">{icon}</div>}
          </div>
        </Row>
        <Text element="h2" size="xlarge" truncate>
          {title}
        </Text>
        <Text color="graphite" size="medium">
          {subtext}
        </Text>
      </Text>
    );
  }

  return (
    <MediaObject
      center={center}
      gutter={gutter}
      className={cx('AvatarWithText', { 'AvatarWithText--Profile': level === 'profile' })}>
      {avatarWithProps}
      <TextWithSubtext
        subtext={subtext}
        subtextSize={subtextSize}
        subtle={subtle}
        textSize={textSize}>
        {title}
      </TextWithSubtext>
    </MediaObject>
  );
}

AvatarWithText.defaultProps = {
  level: 'secondary',
};
